var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavigateTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 7,
    viewBox: "0 0 11 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6925 4.3076C11.1025 4.71765 11.1025 5.38247 10.6925 5.79252C10.2824 6.20257 9.61759 6.20257 9.20754 5.79252L5.95 2.53499L2.69246 5.79252C2.28241 6.20257 1.61759 6.20257 1.20754 5.79252C0.797487 5.38247 0.797487 4.71765 1.20754 4.3076L5.20754 0.307599C5.61759 -0.102452 6.28241 -0.102452 6.69246 0.307599L10.6925 4.3076Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigateTop);
export default __webpack_public_path__ + "static/media/navigate_top.e8b102c25bccace34568f4bb992732e2.svg";
export { ForwardRef as ReactComponent };